{
  "version": 1,
  "asset_id": "6cbd43dd-af4f-4045-903f-1b107dff17cc",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/6cbd43dd-af4f-4045-903f-1b107dff17cc/beylikduzu-hizli-elektrikci-7-24-dukkan-7.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/6cbd43dd-af4f-4045-903f-1b107dff17cc/beylikduzu-hizli-elektrikci-7-24-dukkan-7.jpg",
  "original_filename": "beylikduzu-hizli-elektrikci-7-24-dukkan-7.jpg",
  "size": 386576,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:13:50Z"
}
